import React from 'react';
import PropTypes from 'prop-types';
import { CardWrapper } from './Card.style';

const Card = ({
  children,
  paddingOverride,
  maxHeightOverride,
  marginOverride,
  className
}) => {
  return (
    <CardWrapper
      $paddingOverride={ paddingOverride }
      className={className}
      $maxHeightOverride={maxHeightOverride}
      $marginOverride={marginOverride}
    >
      { children }
    </CardWrapper>
  )
};

Card.propTypes = {
  paddingOverride: PropTypes.string
};

export default Card;
